// @tennis-matches/ui-components/app-toast
// Event-basierte Erfolgs-/Fehler-Toasts — von überall aufrufbar (auch außerhalb React).

export const APP_TOAST_SHOW_EVENT = "app-toast:show";

/**
 * @param {{
 *   kind?: "success" | "error" | "info",
 *   messageKey?: string,
 *   message?: string,
 *   params?: Record<string, unknown>,
 *   durationMs?: number,
 * }} detail
 */
export function showAppToast(detail = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(APP_TOAST_SHOW_EVENT, {
      detail: {
        kind: detail?.kind === "error" || detail?.kind === "info" ? detail.kind : "success",
        messageKey: String(detail?.messageKey || "").trim() || undefined,
        message: String(detail?.message || "").trim() || undefined,
        params: detail?.params && typeof detail.params === "object" ? detail.params : undefined,
        durationMs: Number.isFinite(Number(detail?.durationMs)) ? Number(detail.durationMs) : 3600,
      },
    })
  );
}

/**
 * @param {string} messageKey
 * @param {Record<string, unknown>} [params]
 * @param {{ durationMs?: number }} [options]
 */
export function showAppSuccessToast(messageKey, params, options = {}) {
  showAppToast({
    kind: "success",
    messageKey,
    params,
    durationMs: options.durationMs,
  });
}
